<template>
  <!--////////////////////////////////////////////// Formulario ////////////////////////////////////////////////////////////-->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--Servicio-->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.IDServicio"
          :items="ArrayService"
          :item-title="
            (ArrayService) =>
              ArrayService.ServicioID + '-' + ArrayService.DescripcionServicio
          "
          item-value="ServicioID"
          color="primary"
          label="Servicio:"
          dense
          :clearable="cleared.servicio"
          :readonly="read.servicio"
          :update:modelValue="ChangeServicio()"
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!--Fecha Inicio Administración-->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.FechaIniAdministracion"
          label="Fecha Inicio de administración"
          hint="Digite Información"
          dense
          clearable
          type="date"
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-text-field>
      </v-col>

      <!-- Codigo Servicio 1 -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.CodigoServicio1"
          label="Codigo Servicio / Contrato 1:"
          clearable
          dense
          type="text"
          maxlength="50"
          counter="50"
        >
        </v-text-field>
      </v-col>

      <!-- Codigo Servicio 2 -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.CodigoServicio2"
          label="Codigo Servicio / Contrato 2:"
          clearable
          dense
          type="text"
          maxlength="50"
          counter="50"
        >
        </v-text-field>
      </v-col>
      <!--Empresa EPS-->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.DocumentIDEP"
          :items="ArrayEPS"
          :item-title="(ArrayEPS) => ArrayEPS.DocumentID + '-' + ArrayEPS.Nombre"
          :item-value="(ArrayEPS) => ArrayEPS.TypeDocumentID + '&' + ArrayEPS.DocumentID"
          color="primary"
          label="Empresa Prestadora del Servicio:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Empresa Administradora del servicio-->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.DocumentIDEA"
          :items="ArrayaEmpresaResponsable"
          :item-title="
            (ArrayaEmpresaResponsable) =>
              ArrayaEmpresaResponsable.DocumentID + '-' + ArrayaEmpresaResponsable.Nombre
          "
          :item-value="
            (ArrayaEmpresaResponsable) =>
              ArrayaEmpresaResponsable.TypeDocumentID +
              '&' +
              ArrayaEmpresaResponsable.DocumentID
          "
          color="primary"
          label="Empresa que administra el servicio:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!-- Valor  -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Valor"
          label="Valor:"
          clearable
          dense
          type="tel"
          v-on:keypress="isNumber()"
          maxlength="16"
          counter="16"
        >
        </v-text-field>
      </v-col>
      <!--Aplica Servicio-->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.AplicaServicio"
          :items="ArraySN"
          :item-title="(ArraySN) => ArraySN.Valor + '-' + ArraySN.Descripcion"
          item-value="Valor"
          color="primary"
          label="Aplica Servicio:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>

      <v-expansion-panels
        v-if="editedItem.IDServicio == Servicios.Admon"
        v-model="panel"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-title
            ><h2 align="center">
              <v-icon color="#B6332E" large> mdi-currency-usd </v-icon>
              Información de Pagos
            </h2></v-expansion-panel-title
          >
          <v-expansion-panel-text>
            <v-row>
              <!-- Valor Cuota-->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.ValorCuota"
                  label="Valor Cuota:"
                  clearable
                  dense
                  type="tel"
                  v-on:keypress="isNumber()"
                  maxlength="16"
                  counter="16"
                  @input="calcularDesdePorcentaje"
                >
                </v-text-field>
              </v-col>

              <!-- Valor Cuota Anterior -->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.ValorCuotaAnterior"
                  label="Valor Cuota Anterior:"
                  clearable
                  dense
                  type="tel"
                  v-on:keypress="isNumber()"
                  maxlength="16"
                  counter="16"
                >
                </v-text-field>
              </v-col>

              <!-- Valor Cuota Descuento -->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.ValorCuotaDescuento"
                  label="Valor Cuota Descuento:"
                  clearable
                  dense
                  type="tel"
                  v-on:keypress="isNumber()"
                  @input="calcularDesdeValorDescuento"
                  maxlength="16"
                  counter="16"
                >
                </v-text-field>
              </v-col>

              <!-- Porcentaje Descuento  -->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.PorcentajeDescuento"
                  label="Porcentaje Descuento:"
                  clearable
                  dense
                  type="tel"
                  prefix="%"
                  @input="calcularDesdePorcentaje"
                  v-on:keypress="isNumber()"
                  maxlength="4"
                  counter="4"
                >
                </v-text-field>
              </v-col>

              <!-- Dia límite Descuento  -->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.DiaLimiteDescuento"
                  label="Día Límite Descuento:"
                  clearable
                  dense
                  type="tel"
                  v-on:keypress="isNumber()"
                  maxlength="4"
                  counter="4"
                >
                </v-text-field>
              </v-col>

              <!--Estado Asamblea-->
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  v-model="editedItem.ResponsablePago"
                  :items="ArrayEstadoAsamblea"
                  :item-title="
                    (ArrayEstadoAsamblea) =>
                      ArrayEstadoAsamblea.Valor + '-' + ArrayEstadoAsamblea.Descripcion
                  "
                  item-value="Valor"
                  color="primary"
                  label="Estado Asamblea:"
                  dense
                  clearable
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                >
                </v-autocomplete>
              </v-col>

              <!--Empresa Entidad Bancaria -->
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="editedItem.DocumentIDEF"
                  :items="ArrayEmpresaEntidadBancaria"
                  :item-title="
                    (ArrayEmpresaEntidadBancaria) =>
                      ArrayEmpresaEntidadBancaria.DocumentID +
                      '-' +
                      ArrayEmpresaEntidadBancaria.Nombre
                  "
                  :item-value="
                    (ArrayEmpresaEntidadBancaria) =>
                      ArrayEmpresaEntidadBancaria.TypeDocumentID +
                      '&' +
                      ArrayEmpresaEntidadBancaria.DocumentID
                  "
                  color="primary"
                  label="Empresa que administra el servicio:"
                  dense
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!--Forma de Pago-->
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="editedItem.ModalPago"
                  :items="ArrayFormaPago"
                  :item-title="
                    (ArrayFormaPago) =>
                      ArrayFormaPago.Valor + '-' + ArrayFormaPago.Descripcion
                  "
                  item-value="Valor"
                  color="primary"
                  label="Forma de Pago:"
                  dense
                  clearable
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                >
                </v-autocomplete>
              </v-col>

              <!--Tipo de cuenta-->
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  v-model="editedItem.TipoCuenta"
                  :items="ArrayTipoCuenta"
                  :item-title="
                    (ArrayTipoCuenta) =>
                      ArrayTipoCuenta.Valor + '-' + ArrayTipoCuenta.Descripcion
                  "
                  item-value="Valor"
                  color="primary"
                  label="Tipo de cuenta:"
                  dense
                  clearable
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                >
                </v-autocomplete>
              </v-col>

              <!--Cuenta -->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.Cuenta"
                  label="Cuenta:"
                  hint="Digite Información"
                  dense
                  clearable
                  maxlength="50"
                  counter="50"
                >
                </v-text-field>
              </v-col>

              <!-- Número de convenio -->
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.ConvenioPago"
                  label="Número de convenio de pago:"
                  clearable
                  dense
                  type="tel"
                  maxlength="200"
                  counter="200"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>

      <!--Plataforma de Pago  -->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.PlataformaPago"
          label="Plataforma de Pago:"
          hint="Digite Información"
          dense
          clearable
          maxlength="500"
          counter="500"
        >
        </v-text-field>
      </v-col>

      <!--Responsable del servicio-->
      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="editedItem.Responsable"
          :items="ArrayUser"
          :item-title="
            (ArrayUser) =>
              ArrayUser.Usuario + '-' + ArrayUser.Nombre + ' ' + ArrayUser.Apellido
          "
          item-value="Usuario"
          color="primary"
          label="Responsable del servicio:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!-- Fecha Asignación -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.FechaAsignacion"
          label="Fecha Asignación:"
          clearable
          dense
          type="date"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Seguros from "@/views/TCI/ActivosO/Seguros/Seguros.vue";
import {
  Servicios,
  TipoServicios,
  TipoCliente,
} from "@/views/TCI/ActivosO/Constantes/ConstantesActivos";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
export default {
  name: "rsa_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    llavesiframe: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  components: {
    "card-seguros": Seguros,
  },
  data() {
    return {
      Servicios,
      TipoServicios,
      TablaSeleccion,
      TipoCliente,
      panel: [0, 1],
      progreso: false,
      componenteview: 0,
      modelhojas: null,
      consult: false,
      TipoServicio: null,
      TipoSeguro: null,
      styleObject: { border: "5px solid #B6332E" },
      sheet: [
        {
          icono: "mdi-home-group",
          descripcion: "Activos",
          iconoelegido: 1,
        },
        {
          icono: "mdi-account",
          descripcion: "Cliente EPS",
          iconoelegido: 2,
        },
      ],
      buttonSave: false,
      editedItem: {
        RefActivo: null,
        IDServicio: null,
        EstadoRevision: null,
        EstadoNotificado: null,
        InicioMora: null,
        DiasMora: null,
        DiasMoraFechaValidacion: null,
        PeriodosMora: null,
        ValorMora: null,
        CodigoServicio1: null,
        CodigoServicio2: null,
        Contador: null,
        TypeDocumentEP: null,
        DocumentIDEP: null,
        TypeDocumentEA: null,
        DocumentIDEA: null,
        FechaIniAdministracion: null,
        CicloFacturacion: null,
        CicloPeriocidad: null,
        Valor: null,
        AplicaServicio: "S",
        ModalPago: null,
        ResponsablePago: null,
        MedioPago: null,
        TypeDocumentEF: null,
        DocumentIDEF: null,
        TipoCuenta: null,
        Cuenta: null,
        Responsable: null,
        FechaAsignacion: null,
        SoporteID: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        PlataformaPago: null,
        ConvenioPago: null,
        ValorCuotaDescuento: null,
        DiaLimiteDescuento: null,
      },
      defaultItem: {
        RefActivo: null,
        IDServicio: null,
        EstadoRevision: null,
        EstadoNotificado: null,
        InicioMora: null,
        DiasMora: null,
        DiasMoraFechaValidacion: null,
        PeriodosMora: null,
        ValorMora: null,
        CodigoServicio1: null,
        CodigoServicio2: null,
        Contador: null,
        TypeDocumentEP: null,
        DocumentIDEP: null,
        TypeDocumentEA: null,
        DocumentIDEA: null,
        FechaIniAdministracion: null,
        CicloFacturacion: null,
        CicloPeriocidad: null,
        Valor: null,
        AplicaServicio: "S",
        ModalPago: null,
        ResponsablePago: null,
        MedioPago: null,
        TypeDocumentEF: null,
        DocumentIDEF: null,
        TipoCuenta: null,
        Cuenta: null,
        Responsable: null,
        FechaAsignacion: null,
        SoporteID: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        PlataformaPago: null,
        ConvenioPago: null,
        ValorCuotaDescuento: null,
        DiaLimiteDescuento: null,
      },
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      cleared: {
        servicio: true,
      },
      read: {
        servicio: false,
      },
      ArraySN: [],
      ArrayEstadoAsamblea: [],
      ArrayService: [],
      ArrayEPS: [],
      ArrayUser: [],
      ArrayaEmpresaResponsable: [],
      ArrayFormaPago: [],
      ArrayTipoCuenta: [],
      ArrayEmpresaEntidadBancaria: [],
      wservicio: null,
    };
  },
  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Item editar
    editItem(item, dato) {
      var data = true;
      this.$emit("update:componenteview", item.iconoelegido);
      this.$emit("update:iconodialogbtn", item.icono);
      this.$emit("update:titledialogbtn", item.descripcion);
      this.$emit("update:pageiframe", data);
      switch (item.iconoelegido) {
        case 3: //Clientes
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          break;
        case 4: //Contratos
          this.llaves.Contrato = this.infollaves.Contrato;
          break;
        case 5: //Activos
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 6: //Seguros
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 7:
        case 8:
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          this.llaves.IDServicio = this.infollaves.IDServicio;
          var Soporte = 0;
          if (dato != undefined && dato != null) {
            Soporte = dato;
          } else {
            Soporte = item.Soporte_ID;
          }
          this.llaves.Secuencia_ID = Soporte;
          break;
      }
      this.$emit("update:llavesiframe", this.llaves);
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.RefActivo == "" ||
        this.editedItem.RefActivo == null ||
        this.editedItem.IDServicio == "" ||
        this.editedItem.IDServicio == null ||
        this.editedItem.AplicaServicio == "" ||
        this.editedItem.AplicaServicio == null ||
        this.editedItem.FechaIniAdministracion == "" ||
        this.editedItem.FechaIniAdministracion == null
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        var NTR = [];
        // Empresa prestadora del servicio
        if (this.editedItem.DocumentIDEP != "" && this.editedItem.DocumentIDEP != null) {
          NTR = this.editedItem.DocumentIDEP.split("&");
          this.editedItem.TypeDocumentEP = NTR[0];
          this.editedItem.DocumentIDEP = NTR[1];
        }

        NTR = [];
        // Empresa Administradora del servicio
        if (this.editedItem.DocumentIDEA != "" && this.editedItem.DocumentIDEA != null) {
          NTR = this.editedItem.DocumentIDEA.split("&");
          this.editedItem.TypeDocumentEA = NTR[0];
          this.editedItem.DocumentIDEA = NTR[1];
        }

        NTR = [];
        // Empresa Administradora del servicio publico
        if (this.editedItem.DocumentIDEF != "" && this.editedItem.DocumentIDEF != null) {
          NTR = this.editedItem.DocumentIDEF.split("&");
          this.editedItem.TypeDocumentEF = NTR[0];
          this.editedItem.DocumentIDEF = NTR[1];
        }

        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/ActivosO/R_ServicioAdmin_Activo/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror = registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      this.axios
        .put("/ActivosO/R_ServicioAdmin_Activo/UP0/", this.editedItem)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror = registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Consulta EPS
    async getEPS(TipoFiltro) {
      this.ArrayEPS = [];
      this.axios
        .get("/Personas/Cliente/CD3/" + TipoFiltro)
        .then((response) => {
          this.ArrayEPS = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Empresa Responsable
    async getEmpresaResponsable() {
      this.ArrayaEmpresaResponsable = [];
      this.axios
        .get("/Personas/Cliente/CD3/9")
        .then((response) => {
          this.ArrayaEmpresaResponsable = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Empresa Entidad Bancaria
    async getEmpresaEntidadBancaria() {
      this.ArrayEmpresaEntidadBancaria = [];
      this.axios
        .get("/Personas/Cliente/CD3/" + TipoCliente.AseguradoraEntidadFinanciera)
        .then((response) => {
          this.ArrayEmpresaEntidadBancaria = response.data;
        })
        .catch((e) => console.log(e));
    },
    /////////////////////////////////////////////// Métodos Changes ///////////////////////////////////////////////
    // Función de Estado de revisión
    ChangeServicio() {
      if (this.wservicio != this.editedItem.IDServicio) {
        this.wservicio = this.editedItem.IDServicio;
        if (this.editedItem.IDServicio == "" || this.editedItem.IDServicio == null) {
          this.editedItem.DocumentIDEP = null;
          this.editedItem.DocumentIDEP = null;
          this.ArrayEPS = [];
        } else {
          var TipoFiltro = "0";
          // Tipo servicio
          var Service = this.$store.getters.MServicio.find(
            (item) => item.ServicioID == this.editedItem.IDServicio
          );

          this.TipoServicio = Service ? Service.TipoServicio : null;
          switch (this.TipoServicio) {
            case "1": // Cuota Afiliación
              TipoFiltro = "10";
              break;
            case "2": // Administración
              TipoFiltro = "12";
              break;
            case "3": // Impuesto
              var Service = this.$store.getters.MServicio.find(
                (item) => item.ServicioID == this.editedItem.IDServicio
              );

              var Impuesto = Service ? Service.Impuesto_ID : null;
              if (Impuesto == "3") {
                TipoFiltro = "11";
              } else {
                TipoFiltro = "1";
              }
              break;
            case "4": // Valorización
              TipoFiltro = "1";
              break;
            case "6": // Seguro
              TipoFiltro = "2";
              break;
            case "7": // Comparendos
              TipoFiltro = "11";
              break;
            case "8": // SOAT Y RTM
              TipoFiltro = "11";
              break;
            case TipoServicios.ServicioPublicos: // Servicios Publicos
              TipoFiltro = TipoCliente.EpsServiciosPublicos;
              break;
          }
          this.getEPS(TipoFiltro);
        }
      }
    },

    // Calcular desde porcentaje
    calcularDesdePorcentaje() {
      const cuota = Number(this.editedItem.ValorCuota);
      const porcentaje = Number(this.editedItem.PorcentajeDescuento);

      if (!cuota || porcentaje === null || porcentaje === undefined) return;

      this.editedItem.ValorCuotaDescuento = ((cuota * porcentaje) / 100).toFixed(0);
    },

    // Calcular desde valor descuento
    calcularDesdeValorDescuento() {
      const cuota = Number(this.editedItem.ValorCuota);
      const descuento = Number(this.editedItem.ValorCuotaDescuento);

      if (!cuota || !descuento) return;

      this.editedItem.PorcentajeDescuento = ((descuento * 100) / cuota).toFixed(2);
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    // Cargue Combos
    async CargueCombos() {
      this.ArraySN = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 16
      );

      this.ArrayEstadoAsamblea = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 69
      );

      this.ArrayFormaPago = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.FormaPago
      );

      this.ArrayTipoCuenta = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoCuenta
      );

      var Service = this.$store.getters.MServicio.filter((item) => item.ServicioID != 0);
      this.ArrayService = Service;
      var User = this.$store.getters.MUsers;
      this.ArrayUser = User.filter((item) => item.Usuario.includes("TCI"));
      this.getEmpresaResponsable();
      this.getEmpresaEntidadBancaria();
    },
    // Actualizar carga
    async ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.cleared.servicio = false;
        this.read.servicio = true;
        this.editedItem = this.infoedit;
        //EPS
        if (
          this.editedItem.TypeDocumentEP != null &&
          this.editedItem.TypeDocumentEP != 0 &&
          this.editedItem.DocumentIDEP != null &&
          this.editedItem.DocumentIDEP != ""
        ) {
          this.editedItem.DocumentIDEP =
            this.editedItem.TypeDocumentEP + "&" + this.editedItem.DocumentIDEP;
        } else {
          this.editedItem.DocumentIDEP = null;
        }

        // Empresa Administradora
        if (
          this.editedItem.TypeDocumentEA != null &&
          this.editedItem.TypeDocumentEA != 0 &&
          this.editedItem.DocumentIDEA != null &&
          this.editedItem.DocumentIDEA != ""
        ) {
          this.editedItem.DocumentIDEA =
            this.editedItem.TypeDocumentEA + "&" + this.editedItem.DocumentIDEA;
        } else {
          this.editedItem.DocumentIDEA = null;
        }

        // Empresa Entidad Bancaria
        if (
          this.editedItem.TypeDocumentEF != null &&
          this.editedItem.TypeDocumentEF != 0 &&
          this.editedItem.DocumentIDEF != null &&
          this.editedItem.DocumentIDEF != ""
        ) {
          this.editedItem.DocumentIDEF =
            this.editedItem.TypeDocumentEF + "&" + this.editedItem.DocumentIDEF;
        } else {
          this.editedItem.DocumentIDEF = null;
        }
      } else {
        this.cleared.servicio = true;
        this.read.servicio = false;
        if (this.infollaves != null) {
          this.editedItem.Ref_Activo =
            this.infollaves.Ref_1 != null ? this.infollaves.Ref_1 : null;
          this.editedItem.IDServicio =
            this.infollaves.IDServicio != null ? this.infollaves.IDServicio : null;
        }
      }
    },
  },
  async mounted() {
    await this.CargueCombos();
    await this.ActualizarCargue();
  },
};
</script>
